import { getIdOrNull, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'

export const getShiftActs = (shift, user) => {
  return requestWithPromise(
    `/api/shifts/${getIdOrNull(shift)}/acts`,
    HttpMethods.GET,
    null,
    user
  )
}

export const createShiftAct = (shift, act, user) => {
  return requestWithPromise(
    `/api/shifts/${getIdOrNull(shift)}/acts`,
    HttpMethods.POST,
    act,
    user
  )
}
